import { render, staticRenderFns } from "./WaitingListTest.vue?vue&type=template&id=bca8868c&"
import script from "./WaitingListTest.js?vue&type=script&lang=js&"
export * from "./WaitingListTest.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports